import { render } from "./CountdownSection.vue?vue&type=template&id=4cde3652&scoped=true"
import script from "./CountdownSection.vue?vue&type=script&lang=js"
export * from "./CountdownSection.vue?vue&type=script&lang=js"

import "./CountdownSection.vue?vue&type=style&index=0&id=4cde3652&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cde3652"]])

export default __exports__